import { FC } from 'react';
import { alpha, Chip, chipClasses, ChipProps, styled } from '@mui/material';
import classNames from 'classnames';

import { Icon } from '@components/base';

const StyledChip = styled(Chip)`
  background: ${({ theme }) => alpha(theme.palette.background.paper, 0.8)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: 100%;

  &.icon--end {
    flex-direction: row-reverse;

    .${chipClasses.avatar} {
      margin-right: 4px;
      margin-left: -4px;
    }
  }

  &:hover {
    background: ${({ theme }) => theme.palette.background.paper};
  }

  &.contained {
    background: ${({ theme }) => theme.palette.action.active};
    color: ${({ theme }) => theme.palette.getContrastText(theme.palette.action.active)};

    &:hover {
      background: ${({ theme }) => alpha(theme.palette.action.active, 0.8)};
    }

    .${chipClasses.avatar} {
      color: currentColor;
    }
  }
`;

export type AddOrRemoveButtonProps = Omit<ChipProps, 'avatar' | 'color' | 'icon' | 'variant'> & {
  icon?: 'add' | 'remove' | ChipProps['avatar'];
  iconPlacement?: 'end' | 'start';
  variant?: 'contained' | 'default' | 'outlined';
};

const defaultAvatars = {
  add: <Icon name='add' />,
  remove: <Icon name='remove' />,
};

export const AddOrRemoveButton: FC<AddOrRemoveButtonProps> = ({
  icon,
  iconPlacement = 'start',
  size = 'small',
  variant,
  className,
  ...rest
}) => (
  <StyledChip
    avatar={typeof icon === 'string' ? defaultAvatars[icon] : icon}
    className={classNames(className, variant, `icon--${iconPlacement}`)}
    size={size}
    variant={variant === 'outlined' ? 'outlined' : undefined}
    {...rest}
  />
);
